/** Utility for getting the application/brand name from the active theme
 * Main reason for existence is test mocks or somewhere else in venn-utils package
 * The normal getAppTitle utility cannot be used, as it would create circular dependencies
 * between venn-ui-kit and venn-utils, and it cannot easily be moved out due to strong coupling
 */
export const getAppTitleSimplifiedUtil = (): string => {
  return process.env.APP_TITLE ?? 'Venn';
};
